import { render, staticRenderFns } from "./receiptDialog.vue?vue&type=template&id=6c049c50&scoped=true"
import script from "./receiptDialog.vue?vue&type=script&lang=js"
export * from "./receiptDialog.vue?vue&type=script&lang=js"
import style0 from "./receiptDialog.vue?vue&type=style&index=0&id=6c049c50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c049c50",
  null
  
)

export default component.exports